export interface FormattedAppError {
  message: string;
  supportRef: string;
}

const extractDetailMessage = (error: any): string | null => {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim().length > 0) {
    return detail;
  }

  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim().length > 0) {
      return detail.message;
    }
    if (typeof detail.error === 'string' && detail.error.trim().length > 0) {
      return detail.error;
    }
  }

  const topMessage = error?.response?.data?.message;
  if (typeof topMessage === 'string' && topMessage.trim().length > 0) {
    return topMessage;
  }

  return null;
};

const createSupportRef = (context: string, statusCode?: number): string => {
  const normalized = context
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
    .slice(0, 24) || 'APP';

  const stamp = Date.now().toString(36).toUpperCase();
  const status = statusCode ? String(statusCode) : 'NA';
  return `${normalized}-${status}-${stamp}`;
};

export const formatAppError = (
  error: any,
  context: string,
  fallbackMessage: string,
  statusMessages: Record<number, string> = {}
): FormattedAppError => {
  const statusCode = error?.response?.status as number | undefined;
  const supportRef = createSupportRef(context, statusCode);

  const mapped = statusCode ? statusMessages[statusCode] : undefined;
  const detail = extractDetailMessage(error);
  const message = mapped || detail || fallbackMessage;

  return {
    message: `${message} If this continues, contact support@emotionwise.ai with reference ${supportRef}.`,
    supportRef,
  };
};
